import { useAlertContext } from "../contexts/AlertContext";

export const useAlert = () => {
  return useAlertContext();
};
